/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { Col, Row, Tooltip } from 'react-bootstrap';
import ListGroup from 'react-bootstrap/ListGroup';
import Image from 'react-bootstrap/Image';
import toast from 'react-hot-toast';
import { CheckCircleIcon, ExternalLinkIcon } from '@heroicons/react/solid';

import { DocumentDuplicateIcon } from '@heroicons/react/outline';

import { FiEyeOff, FiEye } from 'react-icons/fi';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import '../flag-icons/css/flag-icons.min.css';

import * as S from './styles';

export interface IHeroListProps {
  listItems: {
    key: string;
    title: string;
    subtitle: string;
    icon: string;
    flag?: string;
    verified?: boolean;
    masked?: boolean;
  }[];
}

export const HeroList = (props: IHeroListProps) => {
  const { listItems } = props;
  const [isMasked, setIsMasked] = useState<boolean>(false);

  const onToggle = () => {
    setIsMasked(!isMasked);
  };

  function start_and_end(str) {
    if (str.length > 25) {
      return (
        str.substr(0, 10) + '.....' + str.substr(str.length - 10, str.length)
      );
    }
    return str;
  }

  const _renderMaskIconIf = (item: any) => {
    if (item?.masked) {
      if (!isMasked)
        return (
          <span onClick={onToggle} className="px-2">
            <FiEye size={15} />
          </span>
        );

      if (isMasked) {
        return (
          <span onClick={onToggle} className="px-2">
            <FiEyeOff size={15} />
          </span>
        );
      }
    }
  };

  function isValidHttpUrl(string) {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
  }

  const mask = (cc, num = 4, mask = '*') =>
    `${cc}`.slice(-num).padStart(`${cc}`.length, mask);

  const _renderSubTitle = (item: any) => {
    const popover = (
      <Popover id="popover-basic">
        <Popover.Body>{item?.subTitle}</Popover.Body>
      </Popover>
    );

    const popover1 = (
      <Popover id="popover-basic">
        <Popover.Body>{'Copy to clipboard'}</Popover.Body>
      </Popover>
    );

    if (item?.subTitle && item?.subTitle?.length > 25) {
      if (isValidHttpUrl(item?.subTitle)) {
        return (
          <>
            <OverlayTrigger trigger="hover" placement="top" overlay={popover}>
              <span>{start_and_end(item?.subTitle)}</span>
            </OverlayTrigger>
            <OverlayTrigger trigger="hover" placement="top" overlay={popover1}>
              <DocumentDuplicateIcon
                onClick={() => {
                  toast.success('copied!');
                  navigator.clipboard.writeText(item?.subTitle);
                }}
                className="icon icon-xs ms-2"
                color="#858585"
                style={{ cursor: 'pointer' }}
              />
            </OverlayTrigger>
            <a href={item?.subTitle} target="_blank">
              <ExternalLinkIcon className="icon icon-xs ms-2" color="#858585" />
            </a>
          </>
        );
      } else {
        return (
          <>
            <OverlayTrigger trigger="hover" placement="top" overlay={popover}>
              <span>{start_and_end(item?.subTitle)}</span>
            </OverlayTrigger>
            <OverlayTrigger trigger="hover" placement="top" overlay={popover1}>
              <DocumentDuplicateIcon
                color="#858585"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  toast.success('copied!');
                  navigator.clipboard.writeText(item?.subTitle);
                }}
                className="icon icon-xs ms-2"
              />
            </OverlayTrigger>
          </>
        );
      }
    }
    if (item?.masked) {
      if (!isMasked) {
        return mask(item?.subTitle, 3);
      }
      if (isMasked) {
        return start_and_end(item?.subTitle);
      }
    } else return start_and_end(item?.subTitle);
  };

  const _renderList = () => {
    // if(listItems && Array.isArray(listItems) && listItems?.length>0){
    //   return null
    // }
    return (
      <>
        {listItems.filter(item=>!!item?.subTitle).map((item, index) => {
          if (item) {
            return (
              <Col xs={12} md={4} key={`${item?.key}-${index}`}>
                <ListGroup>
                  <S.IconContainer>
                    <S.IconImage src={item?.icon} />
                    <div className="px-3 pb-2">
                      <S.Title className="fs-6 mb-0 pb-0">
                        {item?.title}
                        {item?.verified && (
                          <CheckCircleIcon
                            className={`icon icon-xxs text-success me-1`}
                          />
                        )}
                      </S.Title>
                      <S.SubTitle className="fs-6 mb-0 w-100">
                        {item?.flag && (
                          <span class={`fi fi-${item?.flag} fis`}></span>
                        )}{' '}
                        {_renderSubTitle(item)}
                        {_renderMaskIconIf(item)}
                      </S.SubTitle>
                    </div>
                  </S.IconContainer>
                </ListGroup>
              </Col>
            );
          }
        })}
      </>
    );
  };
  return <Row className="flex-start">{_renderList()}</Row>;
};

HeroList.defaultProps = {
  listItems: [],
};
